module.exports = __webpack_public_path__ + "img/img1.568f8a3f.svg";